import { CalendarDate } from "./calendar-date";
export const DEFAULT_TOUR_DURATION_MINUTES = 60;
export const formatDuration = (minutes) => {
    const hours = Math.floor(minutes / 60);
    const mins = minutes % 60;
    if (hours === 0)
        return `${mins}m`;
    if (mins === 0)
        return `${hours}h`;
    return `${hours}h ${mins}m`;
};
export const TOUR_TIME_GRANULARITY_MINUTES = 5;
export const formatTourDate = (dateValue) => {
    const parsed = CalendarDate.parse(dateValue);
    if (!parsed.hasValue) {
        return null;
    }
    return parsed.get().toDate().toLocaleDateString("en-US", {
        month: "short",
        day: "numeric",
        year: "numeric",
    });
};
export const formatTimeOfDay = (timeStr) => {
    if (!timeStr)
        return "";
    const parts = timeStr.split(":");
    const hour = parseInt(parts[0], 10);
    const minutes = (parts[1] || "00").slice(0, 2);
    const ampm = hour >= 12 ? "PM" : "AM";
    const hour12 = hour % 12 || 12;
    return `${hour12}:${minutes} ${ampm}`;
};
export const formatTourTime = (timeStr) => {
    const formatted = formatTimeOfDay(timeStr);
    return formatted ? ` at ${formatted}` : "";
};
const parseTourDate = (dateValue) => {
    const parsed = CalendarDate.parse(dateValue);
    return parsed.hasValue ? parsed.get() : null;
};
const parseTourTime = (timeStr) => {
    if (!timeStr)
        return null;
    const [h, m] = timeStr.split(":").map(Number);
    if (isNaN(h) || isNaN(m))
        return null;
    return { hours: h, minutes: m };
};
const timeIsBeforeNow = (tourTime, nowHours, nowMinutes) => {
    if (tourTime.hours < nowHours)
        return true;
    if (tourTime.hours === nowHours && tourTime.minutes < nowMinutes)
        return true;
    return false;
};
export const splitTours = (tours, now = new Date()) => {
    const today = CalendarDate.fromLocalDate(now);
    const nowHours = now.getHours();
    const nowMinutes = now.getMinutes();
    const upcoming = [];
    const past = [];
    for (const tour of tours) {
        const tourDate = parseTourDate(tour.tourDate);
        if (!tourDate) {
            upcoming.push(tour);
            continue;
        }
        if (tourDate.lessThan(today)) {
            past.push(tour);
        }
        else if (today.lessThan(tourDate)) {
            upcoming.push(tour);
        }
        else {
            const time = parseTourTime(tour.tourTime);
            if (time && timeIsBeforeNow(time, nowHours, nowMinutes)) {
                past.push(tour);
            }
            else {
                upcoming.push(tour);
            }
        }
    }
    const compareAsc = (a, b) => {
        const dateA = parseTourDate(a.tourDate);
        const dateB = parseTourDate(b.tourDate);
        if (!dateA || !dateB)
            return 0;
        if (dateA.lessThan(dateB))
            return -1;
        if (dateB.lessThan(dateA))
            return 1;
        const timeA = parseTourTime(a.tourTime);
        const timeB = parseTourTime(b.tourTime);
        if (!timeA && !timeB)
            return 0;
        if (!timeA)
            return 1;
        if (!timeB)
            return -1;
        if (timeA.hours !== timeB.hours)
            return timeA.hours - timeB.hours;
        return timeA.minutes - timeB.minutes;
    };
    upcoming.sort(compareAsc);
    past.sort((a, b) => -compareAsc(a, b));
    return { upcoming, past };
};
//# sourceMappingURL=tour.js.map